import React, { useEffect } from 'react';

const WorldLandCafe = ({ language, user }) => {
  useEffect(() => {
    // 즉시 새 창 열기
    window.open('/worldlandcafe/index.html', '_blank');
    
    // 원래 페이지로 돌아가기 (선택사항)
    // setTimeout(() => {
    //   window.history.back();
    // }, 1000);
  }, []);

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '50px'
    }}>
      <div>{language === 'KR' ? 'World Land Cafe를 여는 중...' : 'Opening World Land Cafe...'}</div>
    </div>
  );
};

export default WorldLandCafe;